import {NotificationToastService} from '../../services/notification-toast/notification-toast.service';

export abstract class SnackBarAndSpinnerComponent {

    constructor( protected snackBar: NotificationToastService){}

    openSnackBar(messageToDisplay, panelClass): void{
      this.snackBar.openFromPanelClass(messageToDisplay, panelClass);
    }

}
